import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import React from "react";
import ReactDOM from "react-dom/client";
import { version } from "../package.json";
import App from "./App.jsx";

if (import.meta.env.VITE_ENV === "pro") {
	const bugSnagApikey = import.meta.env.VITE_BUGSNAG_APIKEY;

	Bugsnag.start({
		apiKey: bugSnagApikey,
		appVersion: version,
	});
	BugsnagPerformance.start({ apiKey: bugSnagApikey });
}

ReactDOM.createRoot(document.getElementById("root")).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);
